module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1016-581fadd136b9dce2a7cf9375843b558e.png";